module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("101 Things To Do With Popcorn")]), _c('div', {
    staticClass: "toc"
  }, [_c('p', [_c('b', [_vm._v("Table of Contents")])]), _c('dl', [_c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Helpful Hints ")])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Balls & Bars")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Popcorn Balls ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snow Balls ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Butter Balls ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marshmallow Balls ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MMMM Balls ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blue Raspberry Balls ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strawberry Balls ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pumpkin Balls ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oatmeal Bars ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e274",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Pretzel Bars ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e293",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("O’Peter Bars ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e314",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caramel Nut Bars ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e333",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Double Berry Bars ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e366",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P.B. and J. Bars ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e391",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nature’s Sweet Energy Bars ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e414",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Protein Power Bars ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Granola & Trail Mixes")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e437",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not Your Grandma’s Oatmeal Granola ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e466",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Are You Nuts for Granola? ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e497",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salty Granola ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e526",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wasatch Hiker’s Granola ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e557",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mountain Trails ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e572",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Family of Nuts ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e589",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yogurt Raisin Mix ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e606",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teddy Bear Mix ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e633",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sleepover Mix ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e654",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple Cinnamon Mix ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e675",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breakfast on the Run ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e698",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mix It Up! ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e725",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cowboy Mix ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e744",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dorm Room ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Savory Popcorn")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e759",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stovetop Popcorn ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e772",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parmesan ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e791",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30-second Gourmet ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e806",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Like It Hot ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e825",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Taste of the Orient ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e838",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Superb Snack ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e857",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leaning Tower ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e870",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gyro Goodness ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e893",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Good Thyme ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e910",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheese and Chive ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e923",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ooo La La ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e940",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sassy and Savory ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e957",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Italian Delight ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e976",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fire Grilled ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e993",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caesar Corn ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honey Mustard ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Snacks")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kettle Corn ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cookies and Cream ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Very Vanilla ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pecan Pie ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Malted Milk Madness ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caramel Corn ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soft Caramel Corn ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Butter Nut Corn ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toffee Corn ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vanilla Pop ’n’ Nuts ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snickerdoodle ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple Pie a la Mode ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cinnamon Sugar ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1258",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peaches and Cream ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer Strawberry ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blueberry Muffin ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black Cherry Blitz ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1310",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Meringue ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1327",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strawberries and Cream ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strawberry Banana ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1361",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Island Pineapple ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1380",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sour Lemon ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1393",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kool Strawberry ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Popcorn")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1412",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Almond Joy ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1433",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S’mores ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1448",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gooey Goodness ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1469",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Dream Pie ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1488",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Drizzle ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1507",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Pecan ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1526",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Butter Snackers ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1543",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate-Coated Brittle ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1560",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Candy Store ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1577",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("French Cocoa ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1588",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hot Cocoa ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1607",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Blossom ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1624",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Falling for Chocolate ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1641",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Milk Chocolate Hazelnut ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1664",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana Split with Fudge ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1681",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Chocolate Caramel ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1700",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Chocolate Macadamia Nut ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1715",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salty Pecan ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("There’s Popcorn in This?")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1736",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poppin’ Muffins ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1769",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CinnaPop Cake ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1814",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apri-Pop Slices ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1833",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Muffins ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1866",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Popcorn Brownies ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1897",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fudge Crumble Bars ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1937",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana-Pop Bread ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1968",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rooster Snacks ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#tender",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Tenders ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Sandwiches ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grape Pitas ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stuffed Peppers ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Swedish Meatballs ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turkey Stuffing ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metric Conversion Chart")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59b4cf77","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bk01-toc.vue
// module id = 63
// module chunks = 0